import RouteTemplate from 'ember-route-template';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import eq from 'truth-helpers/helpers/eq';
import not from 'truth-helpers/helpers/not';
import and from 'truth-helpers/helpers/and';
import or from 'truth-helpers/helpers/or';
import gt from 'truth-helpers/helpers/gt';
import lt from 'truth-helpers/helpers/lt';
import DEditor from 'discourse/components/d-editor';
import lte from 'truth-helpers/helpers/lte';
import gte from 'truth-helpers/helpers/gte';

export default RouteTemplate(
  <template>
    <div class="admin-plugin-proxyviews pd-admin-unified-crud proxyviews-admin-dashboard">
      <div class="pd-admin-header">
        <div class="header-title-wrapper">
          <div>
            <h2>SEO Content</h2>
            <p class="description">Guides and provider comparisons. This content used to exist only via seed files — this is the first way to create/edit/delete it through the product.</p>
          </div>
        </div>
      </div>
    
      {{#if @controller.message}}
        <div class="pd-toast show {{if (eq @controller.message.type 'danger') 'error' @controller.message.type}}">
          <span class="pd-toast__text">
            {{#if (eq @controller.message.type 'danger')}}
              <span>⚠️</span>
            {{else}}
              <span>✓</span>
            {{/if}}
            {{@controller.message.text}}
          </span>
          <button type="button" class="pd-toast__dismiss" aria-label="Dismiss" {{on "click" @controller.dismissMessage}}>&times;</button>
        </div>
      {{/if}}
    
      <div class="pd-drawer-tabs" style="margin-bottom: 24px;">
        <button type="button" class="tab {{if (eq @controller.activeTab 'guides') 'active'}}" {{on "click" (fn @controller.changeTab 'guides')}}>
          Guides
        </button>
        <button type="button" class="tab {{if (eq @controller.activeTab 'comparisons') 'active'}}" {{on "click" (fn @controller.changeTab 'comparisons')}}>
          Comparisons
        </button>
        <button type="button" class="tab {{if (eq @controller.activeTab 'best-for') 'active'}}" {{on "click" (fn @controller.changeTab 'best-for')}}>
          Best For
        </button>
        <button type="button" class="tab {{if (eq @controller.activeTab 'alternatives') 'active'}}" {{on "click" (fn @controller.changeTab 'alternatives')}}>
          Alternatives
        </button>
        <button type="button" class="tab {{if (eq @controller.activeTab 'robots') 'active'}}" {{on "click" (fn @controller.changeTab 'robots')}}>
          Robots.txt
        </button>
        <button type="button" class="tab {{if (eq @controller.activeTab 'sitemap') 'active'}}" {{on "click" (fn @controller.changeTab 'sitemap')}}>
          Sitemap
        </button>
        <button type="button" class="tab {{if (eq @controller.activeTab 'coverage') 'active'}}" {{on "click" (fn @controller.changeTab 'coverage')}}>
          Coverage
        </button>
      </div>
    
      {{#if (eq @controller.activeTab 'guides')}}
        <div class="pd-admin-filter-bar">
          <input type="text" placeholder="Search guides by title or slug…" value={{@controller.guidesSearch}} class="pd-admin-search-input" {{on "input" @controller.updateGuidesSearch}} />
          {{#if @controller.guidesLoading}}<span class="pd-admin-search-status">Loading…</span>{{/if}}
          <button type="button" class="btn btn-default btn-small" {{on "click" @controller.startNewGuide}}>+ New Guide</button>
        </div>
    
        <div class="pd-category-manager">
          <span class="pd-sidebar-label">Categories:</span>
          {{#each @controller.baseCategories as |c|}}
            <span class="badge badge-type">{{c}}</span>
          {{/each}}
          {{#each @controller.customCategories as |c|}}
            <span class="badge badge-type pd-category-manager__custom">
              {{c}}
              <button type="button" class="pd-category-manager__remove" title="Remove category" {{on "click" (fn @controller.removeCategory c)}}>&times;</button>
            </span>
          {{/each}}
          <input
            type="text"
            placeholder="New category slug…"
            value={{@controller.newCategoryName}}
            class="input-small"
            {{on "input" @controller.updateNewCategoryName}}
          />
          <button type="button" class="btn btn-default btn-small" {{on "click" @controller.addCategory}}>+ Add Category</button>
        </div>
        {{#if @controller.categoryError}}
          <div class="alert alert-error">{{@controller.categoryError}}</div>
        {{/if}}
    
        {{#if @controller.guideFormMode}}
          <div class="pd-seo-modal-overlay" {{on "click" @controller.cancelGuideForm}}>
            <div class="pd-seo-modal" {{on "click" @controller.stopModalClick}}>
              <div class="pd-seo-modal__header">
                <h3>{{if (eq @controller.guideFormMode "edit") "Edit Guide" "New Guide"}}</h3>
                <button type="button" class="pd-seo-modal__close" {{on "click" @controller.cancelGuideForm}}>&times;</button>
              </div>
              <div class="pd-seo-modal__body">
                <div class="pd-admin-form-section">
                  <span class="pd-admin-form-section__label">Basics</span>
                </div>
                <div class="form-grid-row">
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Title <span class="pd-admin-required">*</span></label>
                    <input type="text" placeholder="e.g. How to Choose a Proxy Provider" value={{@controller.guideForm.title}} class="input-medium" {{on "input" @controller.updateGuideTitle}} />
                    <span class="pd-admin-field__hint">Auto-generates the slug if left empty</span>
                  </div>
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Slug</label>
                    <input type="text" placeholder="auto-generated-from-title" value={{@controller.guideForm.slug}} class="input-medium" {{on "input" @controller.updateGuideSlug}} />
                    <span class="pd-admin-field__hint">URL path: /guides/<strong>{{@controller.guideForm.slug}}</strong></span>
                  </div>
                </div>
                <div class="form-grid-row">
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Author</label>
                    <input
                      type="text"
                      placeholder={{if (eq @controller.guideFormMode "new") "Username (defaults to you)" "Leave unchanged to keep, clear to remove"}}
                      value={{@controller.guideForm.authorUsername}}
                      class="input-medium"
                      {{on "input" @controller.updateGuideAuthorUsername}}
                    />
                  </div>
                </div>
                <div class="form-grid-row">
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Category <span class="pd-admin-required">*</span></label>
                    <select {{on "change" (fn @controller.updateGuideField "category")}}>
                      {{#each @controller.categories as |c|}}
                        <option value={{c}} selected={{eq @controller.guideForm.category c}}>{{c}}</option>
                      {{/each}}
                    </select>
                  </div>
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">H1 Override</label>
                    <input type="text" placeholder="Optional — defaults to title" value={{@controller.guideForm.h1}} class="input-medium" {{on "input" (fn @controller.updateGuideField "h1")}} />
                    <span class="pd-admin-field__hint">Only needed if the visible heading should differ from the title</span>
                  </div>
                </div>

                <div class="pd-admin-form-section">
                  <span class="pd-admin-form-section__label">SEO</span>
                </div>
                <div class="form-grid-row">
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Target Keyword</label>
                    <input type="text" placeholder="e.g. best proxy provider" value={{@controller.guideForm.target_keyword}} class="input-medium" {{on "input" (fn @controller.updateGuideField "target_keyword")}} />
                  </div>
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Related Providers</label>
                    <input type="text" placeholder="e.g. oxylabs, bright-data" value={{@controller.guideForm.relatedProviderSlugsText}} class="input-medium" {{on "input" (fn @controller.updateGuideField "relatedProviderSlugsText")}} />
                    <span class="pd-admin-field__hint">Comma-separated slugs — used for related comparisons</span>
                  </div>
                </div>
                <div class="form-grid-row">
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Meta Title</label>
                    <input type="text" placeholder="SEO title for search results" value={{@controller.guideForm.meta_title}} class="input-medium" {{on "input" (fn @controller.updateGuideField "meta_title")}} />
                    <span class="pd-admin-field__char-count {{if (gt @controller.guideForm.meta_title.length 60) 'pd-admin-field__char-count--over'}}">
                      {{@controller.guideForm.meta_title.length}}/60
                    </span>
                  </div>
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Meta Description</label>
                    <input type="text" placeholder="Snippet shown in search results" value={{@controller.guideForm.meta_description}} class="input-medium" {{on "input" (fn @controller.updateGuideField "meta_description")}} />
                    <span class="pd-admin-field__char-count {{if (gt @controller.guideForm.meta_description.length 160) 'pd-admin-field__char-count--over'}}">
                      {{@controller.guideForm.meta_description.length}}/160
                    </span>
                  </div>
                </div>
                <div class="form-grid-row">
                  <div class="pd-admin-field">
                    <label class="pd-admin-field__label">Canonical URL</label>
                    <input type="text" placeholder="Leave blank to use current URL" value={{@controller.guideForm.canonical_url}} class="input-medium" {{on "input" (fn @controller.updateGuideField "canonical_url")}} />
                  </div>
                </div>

                <div class="pd-admin-form-section">
                  <span class="pd-admin-form-section__label">Content</span>
                </div>
                <div class="pd-admin-field">
                  <DEditor
                    @value={{@controller.guideForm.content}}
                    @change={{fn @controller.updateGuideFieldValue "content"}}
                    @showLink={{true}}
                    @placeholder="Write the guide in markdown."
                  />
                  <p class="pd-admin-field__hint">Insert links with [text](https://url) · Bold with **text** · Images with ![alt](url)</p>
                  <div class="pd-admin-field__footer">
                    <span class="pd-word-count {{if @controller.guideWordCountBelowThreshold 'pd-word-count--warning'}}">
                      {{@controller.guideWordCount}} words
                      {{#if @controller.guideWordCountBelowThreshold}}
                        &mdash; under 300 words, will be marked noindex
                      {{/if}}
                    </span>
                  </div>
                </div>

                <div class="pd-admin-form-section">
                  <span class="pd-admin-form-section__label">FAQ</span>
                  <span class="pd-admin-form-section__hint">Optional — appears in an accordion below the guide content</span>
                </div>
                <div class="pd-faq-editor">
                  {{#each @controller.guideForm.faqItems as |item index|}}
                    <div class="pd-faq-editor__row">
                      <div class="pd-faq-editor__drag-handle" title="Drag to reorder">&#9776;</div>
                      <div class="pd-faq-editor__fields">
                        <input
                          type="text"
                          placeholder="Question"
                          value={{item.q}}
                          class="input-medium"
                          {{on "input" (fn @controller.updateFaqItemField index "q")}}
                        />
                        <input
                          type="text"
                          placeholder="Answer"
                          value={{item.a}}
                          class="input-medium"
                          {{on "input" (fn @controller.updateFaqItemField index "a")}}
                        />
                      </div>
                      <span class="pd-faq-editor__index">{{index}}</span>
                      <button
                        type="button"
                        class="btn btn-danger btn-small pd-faq-editor__remove"
                        title="Remove this FAQ item"
                        {{on "click" (fn @controller.removeFaqItem index)}}
                      >
                        &times;
                      </button>
                    </div>
                  {{else}}
                    <p class="description">No FAQ items yet — click "Add FAQ Item" below.</p>
                  {{/each}}
                  <button type="button" class="btn btn-default btn-small" {{on "click" @controller.addFaqItem}}>+ Add FAQ Item</button>
                </div>

                <div class="pd-admin-form-section">
                  <label class="pd-sidebar-label">
                    <input type="checkbox" checked={{@controller.guideForm.published}} {{on "change" (fn @controller.updateGuideField "published")}} />
                    Published
                  </label>
                  <span class="pd-admin-form-section__hint">Unpublished guides are hidden from the public site</span>
                </div>

                {{#if @controller.guideStructuredDataPreview}}
                  <div class="pd-admin-structured-preview">
                    <h4>Structured Data Preview (JSON-LD)</h4>
                    <p class="description">
                      Exactly what this guide will emit in &lt;head&gt; once published — save any edits above
                      first, since this reflects what's currently saved in the database, not the unsaved form.
                    </p>
                    <pre class="pd-robots-preview">{{@controller.guideStructuredDataPreview}}</pre>
                  </div>
                {{/if}}
              </div>

              <div class="pd-seo-modal__footer">
                <div class="pd-seo-modal__footer-left">
                  {{#if (eq @controller.guideFormMode "edit")}}
                    <button
                      type="button"
                      class="btn btn-default btn-small {{if @controller.guideStructuredDataLoading 'disabled'}}"
                      {{on "click" @controller.previewGuideStructuredData}}
                    >
                      {{if @controller.guideStructuredDataLoading "Loading..." "Preview JSON-LD"}}
                    </button>
                  {{/if}}
                </div>
                <div class="pd-seo-modal__footer-right">
                  <button type="button" class="btn btn-default" {{on "click" @controller.cancelGuideForm}}>Cancel</button>
                  <button type="button" class="btn btn-primary {{if (eq @controller.savingId 'save-guide') 'disabled'}}" disabled={{eq @controller.savingId 'save-guide'}} {{on "click" @controller.saveGuide}}>
                    {{#if (eq @controller.savingId 'save-guide')}}
                      Saving...
                    {{else}}
                      Save Guide
                    {{/if}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        {{/if}}
    
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Category</th>
                <th scope="col">Author</th>
                <th scope="col">Words</th>
                <th scope="col">Published</th>
                <th scope="col">Freshness</th>
                <th scope="col">Updated</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.guides as |g|}}
                <tr class="{{if g.published '' 'pd-guide-row--draft'}}">
                  <td>
                    <strong>{{g.title}}</strong>
                    <span class="slug">({{g.slug}})</span>
                    {{#unless g.published}}<span class="pd-guide-status pd-guide-status--draft">Draft</span>{{/unless}}
                  </td>
                  <td>
                    <button
                      type="button"
                      class="badge badge-type pd-category-badge {{if (eq @controller.guideCategoryFilter g.category) 'pd-category-badge--active'}}"
                      {{on "click" (fn @controller.filterByCategory g.category)}}
                    >{{g.category}}</button>
                  </td>
                  <td>{{if g.author_display_name g.author_display_name "—"}}</td>
                  <td>
                    <span class="pd-admin-word-count {{if (lt g.word_count 300) 'pd-admin-word-count--thin'}}">
                      {{g.word_count}}
                    </span>
                  </td>
                  <td class="pd-guide-publish-cell">
                    <button
                      type="button"
                      class="pd-admin-toggle {{if g.published 'pd-admin-toggle--on'}}"
                      {{on "click" (fn @controller.toggleGuidePublished g)}}
                      aria-label={{if g.published "Unpublish" "Publish"}}
                      title={{if g.published "Click to unpublish" "Click to publish"}}
                    >
                      <span class="pd-admin-toggle__track">
                        <span class="pd-admin-toggle__thumb"></span>
                      </span>
                    </button>
                    {{#if g.published_at}}
                      <span class="pd-guide-published-date">{{g.published_at}}</span>
                    {{/if}}
                  </td>
                  <td>{{g.freshness_grade}}</td>
                  <td>{{g.updated_at}}</td>
                  <td class="pd-admin-actions-cell">
                    <div class="pd-admin-actions-group">
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditGuide g)}}>Edit</button>
                      {{#if g.published}}
                        <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.toggleGuidePublished g)}}>Unpublish</button>
                      {{else}}
                        <button type="button" class="btn btn-primary btn-small" {{on "click" (fn @controller.toggleGuidePublished g)}}>Publish</button>
                      {{/if}}
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteGuide g)}}>Delete</button>
                    </div>
                  </td>
                </tr>
              {{else}}
                <tr><td colspan="8" class="empty-results"><p>No guides match this search.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
    
        {{#unless (eq @controller.guidesMeta.total_pages 1)}}
          <nav class="pd-admin-pagination" aria-label="Guide pages">
            <button type="button" class="btn btn-default btn-small pd-page-btn" disabled={{lte @controller.guidesPage 1}} aria-label="Previous page" {{on "click" @controller.prevGuidesPage}}>&larr; Previous</button>
            <span class="pd-admin-pagination__status">Page {{@controller.guidesPage}} of {{@controller.guidesMeta.total_pages}} ({{@controller.guidesMeta.total_count}} guides)</span>
            <button type="button" class="btn btn-default btn-small pd-page-btn" disabled={{gte @controller.guidesPage @controller.guidesMeta.total_pages}} aria-label="Next page" {{on "click" @controller.nextGuidesPage}}>Next &rarr;</button>
          </nav>
        {{/unless}}
      {{/if}}
    
      {{#if (eq @controller.activeTab 'comparisons')}}
        <div class="pd-admin-filter-bar">
          <input type="text" placeholder="Search comparisons…" value={{@controller.comparisonsSearch}} class="pd-admin-search-input" {{on "input" @controller.updateComparisonsSearch}} />
          {{#if @controller.comparisonsLoading}}<span class="pd-admin-search-status">Loading…</span>{{/if}}
          <button type="button" class="btn btn-default btn-small" {{on "click" @controller.startNewComparison}}>+ New Comparison</button>
        </div>
    
        {{#if @controller.comparisonFormMode}}
          <div class="calculator-sections-container">
            <h3>{{if (eq @controller.comparisonFormMode "edit") "Edit Comparison" "New Comparison"}}</h3>
            <div class="pd-admin-new-provider-form pd-admin-form-grid">
              {{#if (eq @controller.comparisonFormMode "new")}}
                <div class="form-grid-row">
                <input type="text" placeholder="Provider A slug" value={{@controller.comparisonForm.provider_a_slug}} class="input-medium" {{on "input" (fn @controller.updateComparisonField "provider_a_slug")}} />
                <input type="text" placeholder="Provider B slug" value={{@controller.comparisonForm.provider_b_slug}} class="input-medium" {{on "input" (fn @controller.updateComparisonField "provider_b_slug")}} />
                </div>
              {{else}}
                <p class="description">{{@controller.comparisonForm.provider_a_slug}} vs {{@controller.comparisonForm.provider_b_slug}} (providers can't be changed after creation — slug is derived from them)</p>
              {{/if}}
              <div class="form-grid-row">
                <input type="text" placeholder="Title (auto-generated if left blank)" value={{@controller.comparisonForm.title}} class="input-medium" {{on "input" (fn @controller.updateComparisonField "title")}} />
                <select class="input-medium" {{on "change" (fn @controller.updateComparisonField "winner_slug")}}>
                  <option value="" selected={{not @controller.comparisonForm.winner_slug}}>No winner</option>
                  <option value={{@controller.comparisonForm.provider_a_slug}} selected={{eq @controller.comparisonForm.winner_slug @controller.comparisonForm.provider_a_slug}}>{{@controller.comparisonForm.provider_a_slug}}</option>
                  <option value={{@controller.comparisonForm.provider_b_slug}} selected={{eq @controller.comparisonForm.winner_slug @controller.comparisonForm.provider_b_slug}}>{{@controller.comparisonForm.provider_b_slug}}</option>
                </select>
              </div>
              <div class="form-grid-row">
                <input type="text" placeholder="Meta description" value={{@controller.comparisonForm.meta_description}} class="input-medium" {{on "input" (fn @controller.updateComparisonField "meta_description")}} />
              </div>
              <label class="pd-sidebar-label">Summary</label>
              <DEditor
                @value={{@controller.comparisonForm.summary}}
                @change={{fn @controller.updateComparisonFieldValue "summary"}}
                @showLink={{true}}
                @placeholder="Short summary shown at the top of the comparison page."
              />
              <label class="pd-sidebar-label">Verdict</label>
              <DEditor
                @value={{@controller.comparisonForm.verdict}}
                @change={{fn @controller.updateComparisonFieldValue "verdict"}}
                @showLink={{true}}
                @placeholder="The closing recommendation / verdict section."
              />

              <label class="pd-sidebar-label">Feature Matrix</label>
              <p class="description">Rows shown in the comparison table. Values are displayed as-is (text or numbers).</p>
              <div class="pd-matrix-editor">
                <div class="pd-matrix-header">
                  <span>Metric</span>
                  <span>{{@controller.comparisonForm.provider_a_slug}}</span>
                  <span>{{@controller.comparisonForm.provider_b_slug}}</span>
                  <span></span>
                </div>
                {{#each @controller.comparisonMatrixRows as |row index|}}
                  <div class="pd-matrix-row">
                    <input type="text" placeholder="e.g. Price per GB" value={{row.metric}} {{on "input" (fn @controller.updateMatrixRow index "metric")}} />
                    <input type="text" placeholder="Value A" value={{row.value_a}} {{on "input" (fn @controller.updateMatrixRow index "value_a")}} />
                    <input type="text" placeholder="Value B" value={{row.value_b}} {{on "input" (fn @controller.updateMatrixRow index "value_b")}} />
                    <button type="button" class="btn btn-danger btn-small pd-matrix-remove" {{on "click" (fn @controller.removeMatrixRow index)}}>&times;</button>
                  </div>
                {{/each}}
                <button type="button" class="btn btn-default btn-small" {{on "click" @controller.addMatrixRow}}>+ Add Row</button>
              </div>
              <label class="pd-sidebar-label">
                <input type="checkbox" checked={{@controller.comparisonForm.published}} {{on "change" (fn @controller.updateComparisonField "published")}} />
                Published
              </label>
              <div>
                <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'save-comparison') 'disabled'}}" {{on "click" @controller.saveComparison}}>
                  {{if (eq @controller.savingId 'save-comparison') "Saving..." "Save Comparison"}}
                </button>
                <button type="button" class="btn btn-default btn-small" {{on "click" @controller.cancelComparisonForm}}>Cancel</button>
                {{#if (eq @controller.comparisonFormMode "edit")}}
                  <button
                    type="button"
                    class="btn btn-default btn-small {{if @controller.comparisonStructuredDataLoading 'disabled'}}"
                    {{on "click" @controller.previewComparisonStructuredData}}
                  >
                    {{if @controller.comparisonStructuredDataLoading "Loading..." "Preview Structured Data"}}
                  </button>
                {{/if}}
              </div>
    
              {{#if @controller.comparisonStructuredDataPreview}}
                <div>
                  <h4>Structured Data Preview (JSON-LD)</h4>
                  <p class="description">
                    Exactly what this comparison will emit in &lt;head&gt; once published — save any edits
                    above first, since this reflects what's currently saved in the database, not the unsaved
                    form.
                  </p>
                  <pre class="pd-robots-preview">{{@controller.comparisonStructuredDataPreview}}</pre>
                </div>
              {{/if}}
            </div>
          </div>
        {{/if}}
    
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Providers</th>
                <th scope="col">Winner</th>
                <th scope="col">Published</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.comparisons as |c|}}
                <tr>
                  <td><strong>{{c.title}}</strong> <span class="slug">({{c.slug}})</span></td>
                  <td>{{c.provider_a_slug}} vs {{c.provider_b_slug}}</td>
                  <td>{{if c.winner_slug c.winner_slug "—"}}</td>
                  <td>
                    <button
                      type="button"
                      class="pd-admin-toggle {{if c.published 'pd-admin-toggle--on'}}"
                      {{on "click" (fn @controller.toggleComparisonPublished c)}}
                      aria-label={{if c.published "Unpublish" "Publish"}}
                      title={{if c.published "Click to unpublish" "Click to publish"}}
                    >
                      <span class="pd-admin-toggle__track">
                        <span class="pd-admin-toggle__thumb"></span>
                      </span>
                    </button>
                  </td>
                  <td class="pd-admin-actions-cell">
                    <div class="pd-admin-actions-group">
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditComparison c)}}>Edit</button>
                      {{#if c.published}}
                        <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.toggleComparisonPublished c)}}>Unpublish</button>
                      {{else}}
                        <button type="button" class="btn btn-primary btn-small" {{on "click" (fn @controller.toggleComparisonPublished c)}}>Publish</button>
                      {{/if}}
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteComparison c)}}>Delete</button>
                    </div>
                  </td>
                </tr>
              {{else}}
                <tr><td colspan="5" class="empty-results"><p>No comparisons match this search.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
    
        {{#unless (eq @controller.comparisonsMeta.total_pages 1)}}
          <nav class="pd-admin-pagination" aria-label="Comparison pages">
            <button type="button" class="btn btn-default btn-small pd-page-btn" disabled={{lte @controller.comparisonsPage 1}} aria-label="Previous page" {{on "click" @controller.prevComparisonsPage}}>&larr; Previous</button>
            <span class="pd-admin-pagination__status">Page {{@controller.comparisonsPage}} of {{@controller.comparisonsMeta.total_pages}} ({{@controller.comparisonsMeta.total_count}} comparisons)</span>
            <button type="button" class="btn btn-default btn-small pd-page-btn" disabled={{gte @controller.comparisonsPage @controller.comparisonsMeta.total_pages}} aria-label="Next page" {{on "click" @controller.nextComparisonsPage}}>Next &rarr;</button>
          </nav>
        {{/unless}}
      {{/if}}
    
      {{#if (eq @controller.activeTab 'best-for')}}
        <div class="pd-admin-tab-bar" style="margin-bottom: 16px;">
          <button type="button" class="tab {{if (eq @controller.bestForFilterTab 'all') 'active'}}" {{on "click" (fn @controller.setBestForFilterTab 'all')}}>All ({{@controller.bestForCounts.all}})</button>
          <button type="button" class="tab {{if (eq @controller.bestForFilterTab 'published') 'active'}}" {{on "click" (fn @controller.setBestForFilterTab 'published')}}>Published ({{@controller.bestForCounts.published}})</button>
          <button type="button" class="tab {{if (eq @controller.bestForFilterTab 'drafts') 'active'}}" {{on "click" (fn @controller.setBestForFilterTab 'drafts')}}>Drafts ({{@controller.bestForCounts.drafts}})</button>
          <button type="button" class="tab {{if (eq @controller.bestForFilterTab 'missing-meta') 'active'}}" {{on "click" (fn @controller.setBestForFilterTab 'missing-meta')}}>Missing Meta ({{@controller.bestForCounts.missingMeta}})</button>
        </div>

        <div class="pd-admin-filter-bar">
          <input
            type="text"
            placeholder="Search Best For use cases by title or slug..."
            value={{@controller.bestForSearch}}
            class="input-medium"
            style="max-width: 320px; margin-right: 12px;"
            {{on "input" @controller.updateBestForSearch}}
          />
          <button type="button" class="btn btn-default btn-small" {{on "click" @controller.startNewBestFor}}>+ New Use Case</button>
        </div>
    
        {{#if @controller.bestForFormMode}}
          <div class="calculator-sections-container">
            <h3>{{if (eq @controller.bestForFormMode "edit") "Edit Use Case" "New Use Case"}}</h3>
            {{#if (eq @controller.bestForFormMode "new")}}
              <div style="margin-bottom: 14px;">
                <span class="pd-sidebar-label" style="display: block; margin-bottom: 6px;">⚡ Quick Presets (Click to autofill):</span>
                <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                  {{#each @controller.BEST_FOR_PRESETS as |preset|}}
                    <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.applyBestForPreset preset)}}>{{preset.label}}</button>
                  {{/each}}
                </div>
              </div>
            {{/if}}
            <div class="pd-admin-new-provider-form pd-admin-form-grid">
              <div class="form-grid-row">
                <input type="text" placeholder="Title (e.g. Best Proxies for Scraping)" value={{@controller.bestForForm.title}} class="input-medium" {{on "input" (fn @controller.updateBestForField "title")}} />
                <input type="text" placeholder="Slug (e.g. scraping)" value={{@controller.bestForForm.slug}} class="input-medium" {{on "input" (fn @controller.updateBestForField "slug")}} disabled={{if (eq @controller.bestForFormMode "edit") true false}} />
              </div>
              <div class="form-grid-row">
                <div style="flex: 1;">
                  <input type="text" placeholder="Meta Title" value={{@controller.bestForForm.meta_title}} class="input-medium" {{on "input" (fn @controller.updateBestForField "meta_title")}} />
                  <span class="pd-guide-published-date" style="margin-top: 4px; display: block;">Meta Title: {{@controller.bestForMetaTitleCount}}/60 chars</span>
                </div>
                <div style="flex: 1;">
                  <input type="text" placeholder="Meta Description" value={{@controller.bestForForm.meta_description}} class="input-medium" {{on "input" (fn @controller.updateBestForField "meta_description")}} />
                  <span class="pd-guide-published-date" style="margin-top: 4px; display: block;">Meta Description: {{@controller.bestForMetaDescriptionCount}}/160 chars</span>
                </div>
              </div>
              <label class="pd-sidebar-label">
                <input type="checkbox" checked={{@controller.bestForForm.published}} {{on "change" (fn @controller.updateBestForField "published")}} />
                Published
              </label>
              <div>
                <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'save-best-for') 'disabled'}}" {{on "click" @controller.saveBestFor}}>
                  {{if (eq @controller.savingId 'save-best-for') "Saving..." "Save Use Case"}}
                </button>
                <button type="button" class="btn btn-default btn-small" {{on "click" @controller.cancelBestForForm}}>Cancel</button>
              </div>
            </div>
          </div>
        {{/if}}
    
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Slug</th>
                <th scope="col">Title</th>
                <th scope="col">SEO Status</th>
                <th scope="col">Published</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.filteredBestForUseCases as |uc|}}
                <tr class="{{if uc.published '' 'pd-guide-row--draft'}}">
                  <td><span class="slug">{{uc.slug}}</span></td>
                  <td>
                    <strong>{{uc.title}}</strong>
                    {{#unless uc.published}}<span class="pd-guide-status pd-guide-status--draft">Draft</span>{{/unless}}
                  </td>
                  <td>
                    {{#if (and uc.meta_title uc.meta_description)}}
                      <span class="badge badge-type">SEO Ready</span>
                    {{else}}
                      <span class="badge badge-type" style="opacity: 0.6;">Missing Meta</span>
                    {{/if}}
                  </td>
                  <td>
                    <button
                      type="button"
                      class="pd-admin-toggle {{if uc.published 'pd-admin-toggle--on'}}"
                      {{on "click" (fn @controller.toggleBestForPublished uc)}}
                      aria-label={{if uc.published "Unpublish" "Publish"}}
                      title={{if uc.published "Click to unpublish" "Click to publish"}}
                    >
                      <span class="pd-admin-toggle__track">
                        <span class="pd-admin-toggle__thumb"></span>
                      </span>
                    </button>
                  </td>
                  <td class="pd-admin-actions-cell">
                    <div class="pd-admin-actions-group">
                      <a href="/best-for/{{uc.slug}}" target="_blank" rel="noopener noreferrer" class="btn btn-default btn-small">View ↗</a>
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.manageProviders uc)}}>Providers</button>
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditBestFor uc)}}>Edit</button>
                      {{#if uc.published}}
                        <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.toggleBestForPublished uc)}}>Unpublish</button>
                      {{else}}
                        <button type="button" class="btn btn-primary btn-small" {{on "click" (fn @controller.toggleBestForPublished uc)}}>Publish</button>
                      {{/if}}
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteBestFor uc)}}>Delete</button>
                    </div>
                  </td>
                </tr>
              {{else}}
                <tr><td colspan="5" class="empty-results"><p>No Best For use cases match this search.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>

        {{#if @controller.managingBestForSlug}}
          <div class="pd-seo-modal-overlay" {{on "click" @controller.closeProviderManager}}>
            <div class="pd-seo-modal" style="max-width: 960px;" {{on "click" @controller.stopModalClick}}>
              <div class="pd-seo-modal__header">
                <h3>Manage Providers — {{@controller.managingBestForTitle}}</h3>
                <button type="button" class="pd-seo-modal__close" {{on "click" @controller.closeProviderManager}}>&times;</button>
              </div>
              <div class="pd-seo-modal__body" style="max-height: 65vh; overflow-y: auto;">

                <div class="pd-admin-form-section">
                  <span class="pd-admin-form-section__label">Add Provider</span>
                </div>
                <div style="margin-bottom: 20px;">
                  <input
                    type="text"
                    placeholder="Search providers by name to pin..."
                    value={{@controller.bestForProviderSearch}}
                    class="input-medium"
                    style="width: 100%; max-width: 420px;"
                    {{on "input" @controller.searchProvidersToAdd}}
                  />
                  {{#if @controller.bestForSearchResults.length}}
                    <div style="margin-top: 8px; border: 1px solid var(--primary-low); border-radius: 8px; max-height: 200px; overflow-y: auto;">
                      {{#each @controller.bestForSearchResults as |result|}}
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; border-bottom: 1px solid var(--primary-low);">
                          <span>
                            <strong>{{result.name}}</strong>
                            <span style="opacity: 0.6; margin-left: 8px; font-size: 0.85rem;">{{result.proxy_type}}</span>
                            {{#if result.overall_rating}}<span style="margin-left: 8px; font-size: 0.85rem;">★ {{result.overall_rating}}</span>{{/if}}
                          </span>
                          <button type="button" class="btn btn-primary btn-small" {{on "click" (fn @controller.addProvider result.id)}}>Pin to Top</button>
                        </div>
                      {{/each}}
                    </div>
                  {{/if}}
                </div>

                {{#if @controller.bestForDirtyOrder}}
                  <div style="margin-bottom: 12px; display: flex; gap: 8px; align-items: center; background: var(--danger-low, rgba(239,68,68,0.08)); padding: 8px 12px; border-radius: 8px;">
                    <span style="color: var(--danger); font-size: 0.85rem; font-weight: 500;">⚠ Unsaved order changes</span>
                    <button type="button" class="btn btn-primary btn-small" {{on "click" @controller.saveOrder}}>Save Order</button>
                  </div>
                {{/if}}

                {{#if @controller.pinnedProviders.length}}
                  <div style="margin-bottom: 24px;">
                    <h4 style="margin-bottom: 8px; color: var(--primary);">📌 Pinned Providers ({{@controller.pinnedProviders.length}})</h4>
                    <table class="pd-admin-table">
                      <thead>
                        <tr>
                          <th style="width: 40px;">#</th>
                          <th>Provider</th>
                          <th>Custom Description</th>
                          <th>Custom Type</th>
                          <th style="width: 200px;">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {{#each @controller.pinnedProviders as |p|}}
                          <tr>
                            <td>
                              <div style="display: flex; flex-direction: column; gap: 2px;">
                                <button type="button" class="btn btn-default btn-small" style="padding: 0 6px; font-size: 0.7rem;" {{on "click" (fn @controller.moveProvider p.provider_id "up")}}>▲</button>
                                <button type="button" class="btn btn-default btn-small" style="padding: 0 6px; font-size: 0.7rem;" {{on "click" (fn @controller.moveProvider p.provider_id "down")}}>▼</button>
                              </div>
                            </td>
                            <td>
                              <strong>{{p.name}}</strong>
                              {{#if p.verified}}<span class="badge badge-type" style="margin-left: 4px; font-size: 0.7rem;">✓ Verified</span>{{/if}}
                              {{#if p.overall_rating}}<span style="margin-left: 4px; font-size: 0.8rem;">★ {{p.overall_rating}}</span>{{/if}}
                            </td>
                            <td>
                              <input
                                type="text"
                                value={{p.description}}
                                placeholder="Override description..."
                                class="input-medium"
                                style="width: 100%; min-width: 200px; font-size: 0.8rem;"
                                {{on "input" (fn @controller.updateCustomField p.provider_id "custom_description")}}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                value={{p.proxy_type}}
                                placeholder="Override type..."
                                class="input-medium"
                                style="width: 120px; font-size: 0.8rem;"
                                {{on "input" (fn @controller.updateCustomField p.provider_id "custom_proxy_type")}}
                              />
                            </td>
                            <td class="pd-admin-actions-cell">
                              <div class="pd-admin-actions-group">
                                <button type="button" class="btn btn-default btn-small" style="font-size: 0.75rem;" {{on "click" (fn @controller.saveCustomField p.provider_id "custom_description" p.description)}}>Save</button>
                                <button type="button" class="btn btn-default btn-small" style="font-size: 0.75rem;" {{on "click" (fn @controller.unpinProvider p.provider_id)}}>Unpin</button>
                                <button type="button" class="btn btn-danger btn-small" style="font-size: 0.75rem;" {{on "click" (fn @controller.excludeProvider p.provider_id)}}>Exclude</button>
                              </div>
                            </td>
                          </tr>
                        {{/each}}
                      </tbody>
                    </table>
                  </div>
                {{/if}}

                {{#if @controller.autoProviders.length}}
                  <div style="margin-bottom: 24px;">
                    <h4 style="margin-bottom: 8px; color: var(--primary);">🔍 Auto-Discovered ({{@controller.autoProviders.length}})</h4>
                    <p style="font-size: 0.85rem; opacity: 0.6; margin-bottom: 8px;">Matched automatically by use case tags. Pin to manually order, or exclude to hide.</p>
                    <table class="pd-admin-table">
                      <thead>
                        <tr>
                          <th>Provider</th>
                          <th>Type</th>
                          <th>Rating</th>
                          <th style="width: 150px;">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {{#each @controller.autoProviders as |p|}}
                          <tr>
                            <td><strong>{{p.name}}</strong></td>
                            <td>{{p.proxy_type}}</td>
                            <td>{{#if p.overall_rating}}★ {{p.overall_rating}}{{else}}—{{/if}}</td>
                            <td class="pd-admin-actions-cell">
                              <div class="pd-admin-actions-group">
                                <button type="button" class="btn btn-default btn-small" style="font-size: 0.75rem;" {{on "click" (fn @controller.pinProvider p.provider_id)}}>Pin</button>
                                <button type="button" class="btn btn-danger btn-small" style="font-size: 0.75rem;" {{on "click" (fn @controller.excludeProvider p.provider_id)}}>Exclude</button>
                              </div>
                            </td>
                          </tr>
                        {{/each}}
                      </tbody>
                    </table>
                  </div>
                {{/if}}

                {{#if @controller.excludedProviders.length}}
                  <div style="margin-bottom: 24px;">
                    <h4 style="margin-bottom: 8px; color: var(--danger);">🚫 Excluded ({{@controller.excludedProviders.length}})</h4>
                    <table class="pd-admin-table">
                      <thead>
                        <tr>
                          <th>Provider</th>
                          <th style="width: 150px;">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {{#each @controller.excludedProviders as |p|}}
                          <tr>
                            <td><strong>{{p.name}}</strong></td>
                            <td class="pd-admin-actions-cell">
                              <div class="pd-admin-actions-group">
                                <button type="button" class="btn btn-default btn-small" style="font-size: 0.75rem;" {{on "click" (fn @controller.restoreProvider p.provider_id)}}>Restore</button>
                              </div>
                            </td>
                          </tr>
                        {{/each}}
                      </tbody>
                    </table>
                  </div>
                {{/if}}

              </div>
              <div class="pd-seo-modal__footer">
                <div class="pd-seo-modal__footer-right">
                  {{#if @controller.bestForDirtyOrder}}
                    <button type="button" class="btn btn-primary btn-small" {{on "click" @controller.saveOrder}}>Save Order</button>
                  {{/if}}
                  <button type="button" class="btn btn-default btn-small" {{on "click" @controller.closeProviderManager}}>Done</button>
                </div>
              </div>
            </div>
          </div>
        {{/if}}
      {{/if}}
    
      {{#if (eq @controller.activeTab 'alternatives')}}
        <div class="pd-admin-filter-bar">
          <button type="button" class="btn btn-default btn-small" {{on "click" @controller.startNewAlternative}}>+ New Alternative Override</button>
        </div>
    
        {{#if @controller.alternativeFormMode}}
          <div class="calculator-sections-container">
            <h3>{{if (eq @controller.alternativeFormMode "edit") "Edit Alternative" "New Alternative"}}</h3>
            <p class="description">Alternatives are auto-generated based on proxy type, but you can override the meta data or explicitly pick the alternatives here.</p>
            <div class="pd-admin-new-provider-form pd-admin-form-grid">
              <div class="form-grid-row">
                <input type="text" placeholder="Provider Slug (e.g. oxylabs)" value={{@controller.alternativeForm.provider_slug}} class="input-medium" {{on "input" (fn @controller.updateAlternativeField "provider_slug")}} disabled={{if (eq @controller.alternativeFormMode "edit") true false}} />
                <input type="text" placeholder="Custom Alternatives Slugs (comma separated)" value={{@controller.alternativeForm.custom_alternatives_slugs_text}} class="input-medium" {{on "input" (fn @controller.updateAlternativeField "custom_alternatives_slugs_text")}} />
              </div>
              <div class="form-grid-row">
                <input type="text" placeholder="Meta Title Override" value={{@controller.alternativeForm.meta_title}} class="input-medium" {{on "input" (fn @controller.updateAlternativeField "meta_title")}} />
                <input type="text" placeholder="Meta Description Override" value={{@controller.alternativeForm.meta_description}} class="input-medium" {{on "input" (fn @controller.updateAlternativeField "meta_description")}} />
              </div>
              <div>
                <button type="button" class="btn btn-primary btn-small {{if (eq @controller.savingId 'save-alternative') 'disabled'}}" {{on "click" @controller.saveAlternative}}>
                  {{if (eq @controller.savingId 'save-alternative') "Saving..." "Save Alternative"}}
                </button>
                <button type="button" class="btn btn-default btn-small" {{on "click" @controller.cancelAlternativeForm}}>Cancel</button>
              </div>
            </div>
          </div>
        {{/if}}
    
        <div class="pd-admin-table-container">
          <table class="pd-admin-table">
            <thead>
              <tr>
                <th scope="col">Provider Slug</th>
                <th scope="col">Custom Alternatives</th>
                <th scope="col">Meta Overrides</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {{#each @controller.alternatives as |alt|}}
                <tr>
                  <td><strong>{{alt.provider_slug}}</strong></td>
                  <td>{{if alt.custom_alternatives_slugs.length "Yes" "No"}}</td>
                  <td>{{if alt.meta_title "Yes" "No"}}</td>
                  <td class="pd-admin-actions-cell">
                    <div class="pd-admin-actions-group">
                      <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditAlternative alt)}}>Edit</button>
                      <button type="button" class="btn btn-danger btn-small" {{on "click" (fn @controller.deleteAlternative alt)}}>Delete</button>
                    </div>
                  </td>
                </tr>
              {{else}}
                <tr><td colspan="4" class="empty-results"><p>No alternative overrides defined.</p></td></tr>
              {{/each}}
            </tbody>
          </table>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'robots')}}
        <div class="calculator-sections-container pd-robots-panel">
          <h3>robots.txt</h3>
          <p class="description">
            By default this site serves Discourse's standard robots.txt (controlled by
            <code>allow_index_in_robots_txt</code> in Admin &gt; Settings). Turning this on replaces it with a
            version this plugin generates and manages, including a `Sitemap:` line pointing at this plugin's
            sitemap. Turning it back off restores Discourse's default behavior immediately &mdash; nothing is
            lost.
          </p>
    
          <label class="pd-sidebar-label pd-robots-toggle">
            <input type="checkbox" checked={{@controller.robotsEnabled}} {{on "change" @controller.toggleRobotsEnabled}} />
            Serve a custom robots.txt managed by this plugin
          </label>
    
          <div class="pd-admin-new-provider-form pd-admin-new-provider-form--stacked">
            <label class="pd-sidebar-label" for="pd-robots-custom-rules">
              Extra rules (appended after the default Disallow rules, before the Sitemap line)
            </label>
            <textarea
              id="pd-robots-custom-rules"
              placeholder="e.g. Disallow: /some-internal-path"
              rows="6"
              class="pd-admin-textarea"
              disabled={{unless @controller.robotsEnabled "disabled"}}
              {{on "input" @controller.updateRobotsCustomRules}}
            >{{@controller.robotsCustomRules}}</textarea>
    
            <div class="pd-robots-sandbox">
              <label class="pd-sidebar-label" for="pd-robots-draft">Sandbox — test draft rules without saving</label>
              <textarea
                id="pd-robots-draft"
                placeholder="Enter draft rules to preview without saving..."
                rows="6"
                class="pd-admin-textarea"
                {{on "input" @controller.updateDraftRobotsRules}}
              >{{@controller.draftRobotsRules}}</textarea>
              <div>
                <button
                  type="button"
                  class="btn btn-default btn-small {{if @controller.draftLoading 'disabled'}}"
                  {{on "click" @controller.previewDraft}}
                >
                  {{if @controller.draftLoading "Testing..." "Test Draft"}}
                </button>
              </div>
              {{#if @controller.draftPreview}}
                <pre class="pd-robots-preview">{{@controller.draftPreview}}</pre>
              {{/if}}
            </div>
    
            <div>
              <button
                type="button"
                class="btn btn-primary btn-small {{if @controller.robotsSaving 'disabled'}}"
                {{on "click" @controller.saveRobots}}
              >
                {{if @controller.robotsSaving "Saving..." "Save Robots.txt Settings"}}
              </button>
            </div>
    
            {{#if @controller.robotsUpdatedAt}}
              <p class="description">Last saved {{@controller.robotsUpdatedAt}} by {{@controller.robotsUpdatedBy}}.</p>
            {{/if}}
          </div>
    
          <h4>Preview (as of last save)</h4>
          <pre class="pd-robots-preview">{{@controller.robotsPreview}}</pre>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'sitemap')}}
        <div class="calculator-sections-container pd-robots-panel">
          <h3>Sitemap</h3>
          <p class="description">
            This plugin auto-generates a sitemap covering guides, comparisons, providers, long-tail keyword
            pages, best-for pages, and alternatives pages, served at the URL below. It's cached for 24 hours
            after each build — use "Regenerate Now" after a bulk content change instead of waiting for the
            cache to expire naturally.
          </p>
    
          <div class="pd-admin-stats">
            <div class="pd-admin-stat-card">
              <div class="stat-header"><span class="label">Status</span></div>
              <span class="value">{{if @controller.sitemapEnabled "Enabled" "Disabled"}}</span>
            </div>
            <div class="pd-admin-stat-card">
              <div class="stat-header"><span class="label">URLs (last build)</span></div>
              <span class="value">{{if @controller.sitemapUrlCount @controller.sitemapUrlCount "—"}}</span>
            </div>
            <div class="pd-admin-stat-card">
              <div class="stat-header"><span class="label">Last Generated</span></div>
              <span class="value">{{if @controller.sitemapLastGeneratedAt @controller.sitemapLastGeneratedAt "Never"}}</span>
            </div>
          </div>
    
          {{#unless @controller.sitemapEnabled}}
            <p class="description">
              Sitemap generation is currently off (<code>proxyviews_seo_sitemap_enabled</code> site setting).
              The URL below will 404 until it's turned back on in Admin &gt; Settings.
            </p>
          {{/unless}}
    
          <p class="description">
            Sitemap URL: <a href={{@controller.sitemapUrl}} target="_blank" rel="noopener noreferrer">{{@controller.sitemapUrl}}</a>
            <button type="button" class="btn btn-default btn-small" style="margin-left: 10px;" {{on "click" @controller.copySitemapUrl}}>📋 Copy URL</button>
          </p>
    
          <div>
            <button
              type="button"
              class="btn btn-primary btn-small {{if @controller.sitemapRegenerating 'disabled'}}"
              {{on "click" @controller.regenerateSitemap}}
            >
              {{if @controller.sitemapRegenerating "Regenerating..." "Regenerate Now"}}
            </button>
          </div>
        </div>
      {{/if}}
    
      {{#if (eq @controller.activeTab 'coverage')}}
        <div class="calculator-sections-container">
          <h3>SEO Coverage Report</h3>
          <p class="description">
            Guides and comparisons that currently have SEO issues (e.g. thin content, missing meta fields,
            unpublished, noindex). Load the report to inspect what search engines are skipping.
          </p>
    
          {{#if @controller.coverageLoading}}
            <div class="pd-admin-search-status">Loading…</div>
          {{/if}}
    
          {{#unless @controller.coverageData}}
            {{#unless @controller.coverageLoading}}
              <div>
                <button type="button" class="btn btn-primary btn-small" {{on "click" @controller.loadCoverage}}>
                  Load Coverage Report
                </button>
              </div>
            {{/unless}}
          {{else}}
            {{#if @controller.coverageData.totals}}
              <div class="pd-admin-stats">
                <div class="pd-admin-stat-card">
                  <div class="pd-hub-stat"><span class="stat-label">Guides Total</span></div>
                  <span class="stat-value">{{@controller.coverageData.totals.guides_total}}</span>
                </div>
                <div class="pd-admin-stat-card">
                  <div class="pd-hub-stat"><span class="stat-label">Guides with Issues</span></div>
                  <span class="stat-value">{{@controller.coverageData.totals.guides_with_issues_count}}</span>
                </div>
                <div class="pd-admin-stat-card">
                  <div class="pd-hub-stat"><span class="stat-label">Comparisons Total</span></div>
                  <span class="stat-value">{{@controller.coverageData.totals.comparisons_total}}</span>
                </div>
                <div class="pd-admin-stat-card">
                  <div class="pd-hub-stat"><span class="stat-label">Comparisons with Issues</span></div>
                  <span class="stat-value">{{@controller.coverageData.totals.comparisons_with_issues_count}}</span>
                </div>
              </div>
            {{/if}}
    
            <h4>Guides with issues</h4>
            <div class="pd-admin-table-container">
              <table class="pd-admin-table">
                <thead>
                  <tr>
                    <th scope="col">Title</th>
                    <th scope="col">Slug</th>
                    <th scope="col">Issues</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {{#each @controller.coverageData.guides_with_issues as |g|}}
                    <tr>
                      <td><strong>{{g.title}}</strong></td>
                      <td class="description-text">{{g.slug}}</td>
                      <td>
                        {{#each g.issues as |issue|}}
                          <span class="badge badge-type">{{issue}}</span>
                        {{/each}}
                      </td>
                      <td class="pd-admin-actions-cell">
                        <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditGuide g)}}>Fix & Edit</button>
                      </td>
                    </tr>
                  {{else}}
                    <tr><td colspan="4" class="empty-results"><p>No guides with issues.</p></td></tr>
                  {{/each}}
                </tbody>
              </table>
            </div>
    
            <h4>Comparisons with issues</h4>
            <div class="pd-admin-table-container">
              <table class="pd-admin-table">
                <thead>
                  <tr>
                    <th scope="col">Title</th>
                    <th scope="col">Slug</th>
                    <th scope="col">Issues</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {{#each @controller.coverageData.comparisons_with_issues as |c|}}
                    <tr>
                      <td><strong>{{c.title}}</strong></td>
                      <td class="description-text">{{c.slug}}</td>
                      <td>
                        {{#each c.issues as |issue|}}
                          <span class="badge badge-type">{{issue}}</span>
                        {{/each}}
                      </td>
                      <td class="pd-admin-actions-cell">
                        <button type="button" class="btn btn-default btn-small" {{on "click" (fn @controller.startEditComparison c)}}>Fix & Edit</button>
                      </td>
                    </tr>
                  {{else}}
                    <tr><td colspan="4" class="empty-results"><p>No comparisons with issues.</p></td></tr>
                  {{/each}}
                </tbody>
              </table>
            </div>
          {{/unless}}
        </div>
      {{/if}}
    </div>
  </template>
);
